import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IAppConfig } from './models/IAppConfig';
import { BuildDetailsHttpService } from './services/build-details-http.service';

@Injectable()
export class AppConfig {
  static settings: IAppConfig;

  constructor(
    private http: HttpClient,
    private buildService: BuildDetailsHttpService
  ) { }

  loadAppConfig(): Promise<void> {    
    return new Promise<void>((resolve, reject) => {
      
      this.buildService.fetchBuildDetails().then(buildDetails => {
  
        const jsonFile = `assets/config/config.${environment.configuration_name}.json?${buildDetails.buildNumber}`;
        this.http.get(jsonFile).toPromise().then((response: Object) => {         
          AppConfig.settings = <IAppConfig>response;
          
          // parse Dates in config
          const pricing = (<any>response).CustomerPricing;
          AppConfig.settings.CustomerPricing.Available = pricing.Available ? new Date(`${pricing.Available}T00:00:00`) : null;
          const effective = AppConfig.settings.CustomerPricing.Effective = pricing.Effective ? new Date(`${pricing.Effective}T00:00:00`) : null;
          const today = new Date();
          if(effective != null && effective >= today) {
            AppConfig.settings.CustomerPricing.AsOfParam = '&asof=' + effective.format('yyyy-M-d');
          }

          console.log('CONFIG: ' + jsonFile, AppConfig.settings);
          resolve()
        }).catch((response: any) => {
          reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
        })
      })
  
    })
  }
}
